import AccordionText from '~/components/AccordionText'
import ArticlePush from '~/components/ArticlePush'
import Clients from '~/components/Clients'
import CurveComponent from '~/components/CurveComponent'
import EditoAlternateTextImage from '~/components/EditoAlternateTextImage'
import EditoBulletSteps from '~/components/EditoBulletSteps'
import EditoCenteredImageText from '~/components/EditoCenteredImageText'
import EditoCenteredText from '~/components/EditoCenteredText'
import EditoColumnImageText from '~/components/EditoColumnImageText'
import EditoDoubleImage from '~/components/EditoDoubleImage'
import EditoPush from '~/components/EditoPush'
import EditoSliderImages from '~/components/EditoSliderImages'
import GridImageText from '~/components/GridImageText'
import HeroEdito from '~/components/HeroEdito'
import HeroMain from '~/components/HeroMain'
import Jobs from '~/components/Jobs'
import LineDocuments from '~/components/LineDocuments'
import ListIcons from '~/components/ListIcons'
import ListImageText from '~/components/ListImageText'
import LogoList from '~/components/LogoList'
import Pricings from '~/components/Pricings'
import Quotes from '~/components/Quotes'
import Separator from '~/components/Separator'
import { MapSliceTypeToComponent } from '~/components/SliceManager'

/**
 * Universal map slice components imports
 */
const mapSliceToComponent: MapSliceTypeToComponent = {
  accordion_text: AccordionText,
  article_push: ArticlePush,
  clients: Clients,
  curve_component: CurveComponent,
  edito_alternate_text_image: EditoAlternateTextImage,
  edito_bullet_steps: EditoBulletSteps,
  edito_centered_image_text: EditoCenteredImageText,
  edito_centered_text: EditoCenteredText,
  edito_column_image_text: EditoColumnImageText,
  edito_double_image: EditoDoubleImage,
  edito_push: EditoPush,
  edito_slider_images: EditoSliderImages,
  grid_image_text: GridImageText,
  hero_edito: HeroEdito,
  hero_main: HeroMain,
  line_documents: LineDocuments,
  list_icons: ListIcons,
  list_image_text: ListImageText,
  logo_list: LogoList,
  pricings: Pricings,
  quotes: Quotes,
  separator: Separator,
  jobs: Jobs
}

export default mapSliceToComponent
